var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Link as LinkDom } from 'react-router-dom';
import { getColor, getColors } from './Classes';
import { Tooltip } from '@mui/material';
import { Typography } from './Typography';
export var Link = function (_a) {
    var _b = _a.title, title = _b === void 0 ? '' : _b, _c = _a.children, children = _c === void 0 ? null : _c, _d = _a.className, className = _d === void 0 ? '' : _d, _e = _a.style, style = _e === void 0 ? {} : _e, _f = _a.color, color = _f === void 0 ? 'primary' : _f, _g = _a.icon, icon = _g === void 0 ? null : _g, _h = _a.bold, bold = _h === void 0 ? false : _h, props = __rest(_a, ["title", "children", "className", "style", "color", "icon", "bold"]);
    var palette = getColors();
    var content = (_jsx(LinkDom, __assign({ style: __assign({ color: getColor(palette, color) }, style), className: "no-text-decoration ".concat(className) }, props, { children: children ? (children) : (_jsx(Typography, __assign({ className: bold ? 'bold' : '', variant: "body2", startIcon: icon }, { children: title }))) })));
    if (title) {
        return (_jsx(Tooltip, __assign({ disableInteractive: true, title: title }, { children: content })));
    }
    return content;
};
//# sourceMappingURL=Link.js.map